export type DisplayedColumn = {
    def: string;
    label: string;
    group: string;
    subgroup?: string;
    format?: string;
    hidden?: boolean;
    width?: number;
    draggable?: boolean;
    leftAligned?: boolean;
};

export const allExportFlightColumns: DisplayedColumn[] = [
    { def: "flightDate.date", label: "Date", group: "info", format: "d/M/yyyy", width: 108, draggable: true },
    { def: "helicopter.type", label: "Aircraft Type", group: "info", width: 146 },
    { def: "helicopter.registrationMark", label: "Registration Mark", group: "info", width: 158 },
    { def: "flightType", label: "Flight Type", group: "info", width: 122, draggable: true },
    { def: "flightId", label: "", group: "", hidden: true },
    { def: "passengers", label: "Nr. Pax", group: "info", subgroup: "pax", format: "n0", width: 100 },
    { def: "payingPassengers", label: "Nr. Paying Pax", group: "info", subgroup: "pax", format: "n0", width: 168 },
    { def: "taxPassengers", label: "Nr. Paying Pax (with tax)", group: "info", subgroup: "pax", format: "n0", width: 168 },
    { def: "crew", label: "Crew Members", group: "info", subgroup: "crew", width: 150, draggable: true, leftAligned: true },
    { def: "crewRole", label: "Crew Role", group: "info", subgroup: "crew", width: 116, draggable: true, leftAligned: true },
    { def: "departurePlace", label: "From", group: "info", width: 200, draggable: true, leftAligned: true },
    { def: "arrivalPlace", label: "To", group: "info", width: 200, draggable: true, leftAligned: true },
    { def: "pilot1Name", label: "Pilot", group: "info", width: 126, draggable: true, leftAligned: true },
    { def: "pilot1Role", label: "Pilot Role", group: "info", width: 130, draggable: true },
    { def: "pilot2Name", label: "Copilot", group: "info", width: 126, draggable: true, leftAligned: true },
    { def: "pilot2Role", label: "Copilot role", group: "info", width: 130, draggable: true },
    { def: "blockNumber", label: "Block Nr.", group: "info", width: 112 },
    { def: "documentNumber", label: "Page Nr.", group: "info", width: 112, draggable: true },
    { def: "isPositioning", label: "Is Positioning", group: "info", width: 142, draggable: true },
    { def: "massBalanceCode", label: "Mass & Balance Code", group: "info", width: 180, draggable: true },
    { def: "flightNumber", label: "Flight Nr.", group: "info", width: 112 },
    { def: "startTime", label: "Start", group: "info", subgroup: "time", format: "HH:mm", width: 100 },
    { def: "stopTime", label: "Stop", group: "info", subgroup: "time", format: "HH:mm", width: 100 },
    { def: "startStopTime", label: "h:mm", group: "info", subgroup: "startstop", format: "[h]:mm", width: 106 },
    { def: "startStopTimeMin", label: "minutes", group: "info", subgroup: "startstop", width: 106, format: "n0" },
    { def: "takeOffTime", label: "Take Off Time", group: "info", width: 138, format: "HH:mm" },
    { def: "landingTime", label: "Landing Time", group: "info", width: 138, format: "HH:mm" },
    { def: "flightTime", label: "h:mm", group: "info", subgroup: "flighttime", format: "[h]:mm", width: 106 },
    { def: "flightTimeMin", label: "minutes", group: "info", subgroup: "flighttime", width: 106, format: "n0" },
    { def: "helicopter.airFrameActualTotFh", label: "A. Total FH", group: "info", subgroup: "aTot", format: "[h]:mm", width: 132 },
    { def: "helicopter.airFrameActualTotCycles", label: "A. Total Cycles", group: "info", subgroup: "aTot", format: "n0", width: 142 },
    { def: "cycles", label: "A/C Cycles", group: "info", format: "n0", width: 128 },
    { def: "hook.cycles", label: "cycles", group: "info", subgroup: "hook", format: "n0", width: 128 },
    { def: "hook.hours", label: "hours", group: "info", subgroup: "hook", format: "HH:mm", width: 106 },
    { def: "totalCycles", label: "Total Cycles", group: "info", format: "n0", width: 128 },
    { def: "hoist.cycles", label: "cycles", group: "info", subgroup: "hoist", format: "n0", width: 106 },
    { def: "hoist.hours", label: "hours", group: "info", subgroup: "hoist", format: "HH:mm", width: 106 },
    { def: "helicopter.engine1N1", label: "N1/NQ", group: "info", subgroup: "e1", width: 128 },
    { def: "helicopter.engine1N2", label: "N2", group: "info", subgroup: "e1", width: 90 },
    { def: "helicopter.engine1Imp", label: "IMP/CREEP(%)", group: "info", subgroup: "e1", width: 142 },
    { def: "helicopter.engine2N1", label: "N1/NQ", group: "info", subgroup: "e2", width: 128 },
    { def: "helicopter.engine2N2", label: "N2", group: "info", subgroup: "e2", width: 90 },
    { def: "helicopter.engine2Imp", label: "IMP/CREEP(%)", group: "info", subgroup: "e2", width: 142 },
    { def: "helicopter.engine1TotFH", label: "E1 Tot. FH", group: "totals", subgroup: "eTot", format: "[h]:mm", width: 128 },
    { def: "helicopter.engine1TotN1", label: "E1 Tot. N1/NQ", group: "totals", subgroup: "eTot", width: 146 },
    { def: "helicopter.engine1TotN2", label: "E1 Tot. N2", group: "totals", subgroup: "eTot", width: 128 },
    { def: "helicopter.engine1TotImp", label: "E1 Tot. IMP/CREEP(%)", group: "totals", subgroup: "eTot", width: 184 },
    { def: "helicopter.engine2TotFH", label: "E2 Tot. FH", group: "totals", subgroup: "eTot", format: "[h]:mm", width: 128 },
    { def: "helicopter.engine2TotN1", label: "E2 Tot. N1/NQ", group: "totals", subgroup: "eTot", width: 146 },
    { def: "helicopter.engine2TotN2", label: "E2 Tot. N2", group: "totals", subgroup: "eTot", width: 128 },
    { def: "helicopter.engine2TotImp", label: "E2 Tot. IMP/CREEP(%)", group: "totals", subgroup: "eTot", width: 184 },
    { def: "fuelType", label: "Fuel Type", group: "fuel", width: 128 },
    { def: "totalFuelBeforeNextFlight", label: "value", group: "fuel", subgroup: "tfbnf", format: "n2", width: 108 },
    { def: "totalFuelBeforeNextFlightUnit", label: "unit", group: "fuel", subgroup: "tfbnf", width: 108 },
    { def: "fuelArrival", label: "value", group: "fuel", subgroup: "farr", format: "n2", width: 90 },
    { def: "fuelArrivalUnit", label: "unit", group: "fuel", subgroup: "farr", width: 90 },
    { def: "refuel", label: "value", group: "fuel", subgroup: "refuel", format: "n2", width: 90 },
    { def: "refuelUnit", label: "unit", group: "fuel", subgroup: "refuel", width: 90 },
    { def: "totalFuel", label: "value", group: "fuel", subgroup: "tfuel", format: "n2", width: 90 },
    { def: "totalFuelUnit", label: "unit", group: "fuel", subgroup: "tfuel", width: 90 },
    { def: "refuelBeforeFirstFlight", label: "value", group: "fuel", subgroup: "rbbf", format: "n2", width: 102 },
    { def: "refuelBeforeFirstFlightUnit", label: "unit", group: "fuel", subgroup: "rbbf", width: 102 },
    { def: "refuelBeforeFirstFlightDate", label: "Date", group: "fuel", subgroup: "rbbf", format: "d/M/yyyy", width: 102 },
    { def: "firstRefuelLocation", label: "Refuel", group: "fuel", subgroup: "location", width: 196, leftAligned: true },
    { def: "secondRefuelLocation", label: "Refuel Before First Flight", group: "fuel", subgroup: "location", width: 196, leftAligned: true },
    { def: "defect", label: "Defect", group: "defects", width: 254, leftAligned: true },
    { def: "actionTaken", label: "Action Taken", group: "defects", width: 254, leftAligned: true },
    { def: "oilSupplied.hyd", label: "value", group: "oil", subgroup: "hyd", format: "n2", width: 90 },
    { def: "oilSupplied.hydUnit", label: "unit", group: "oil", subgroup: "hyd", width: 90 },
    { def: "oilSupplied.mgb", label: "value", group: "oil", subgroup: "mgb", format: "n2", width: 90 },
    { def: "oilSupplied.mgbUnit", label: "unit", group: "oil", subgroup: "mgb", width: 90 },
    { def: "oilSupplied.tgb", label: "value", group: "oil", subgroup: "tgb", format: "n2", width: 90 },
    { def: "oilSupplied.tgbUnit", label: "unit", group: "oil", subgroup: "tgb", width: 90 },
    { def: "oilSupplied.engine1", label: "value", group: "oil", subgroup: "e1", format: "n2", width: 90 },
    { def: "oilSupplied.engine1Unit", label: "unit", group: "oil", subgroup: "e1", width: 90 },
    { def: "oilSupplied.engine2", label: "value", group: "oil", subgroup: "e2", format: "n2", width: 90 },
    { def: "oilSupplied.engine2Unit", label: "unit", group: "oil", subgroup: "e2", width: 90 },
    { def: "penality", label: "Penality", group: "penality", width: 104, draggable: true },
    { def: "enginePowerCheck.oat", label: "OAT", group: "epc", width: 90 },
    { def: "enginePowerCheck.altitude", label: "Altitude", group: "epc", width: 104 },
    { def: "enginePowerCheck.engine1N1NG", label: "N1/NG", group: "epc", subgroup: "e1", width: 116 },
    { def: "enginePowerCheck.engine1NR", label: "nr.", group: "epc", subgroup: "e1", width: 116 },
    { def: "enginePowerCheck.engine1TOTITT", label: "TOT/ITT", group: "epc", subgroup: "e1", width: 116 },
    { def: "enginePowerCheck.engine1TQ", label: "Tq", group: "epc", subgroup: "e1", width: 116 },
    { def: "enginePowerCheck.engine2N1NG", label: "N1/NG", group: "epc", subgroup: "e2", width: 116 },
    { def: "enginePowerCheck.engine2NR", label: "nr.", group: "epc", subgroup: "e2", width: 116 },
    { def: "enginePowerCheck.engine2TOTITT", label: "TOT/ITT", group: "epc", subgroup: "e2", width: 116 },
    { def: "enginePowerCheck.engine2TQ", label: "Tq", group: "epc", subgroup: "e2", width: 116 },
    { def: "enginePowerCheck.engine1DeltaN1", label: "ΔN1", group: "epc", subgroup: "Δe1", width: 116 },
    { def: "enginePowerCheck.engine1deltaT4", label: "ΔT4", group: "epc", subgroup: "Δe1", width: 116 },
    { def: "enginePowerCheck.engine1DeltaTOT", label: "ΔTOT", group: "epc", subgroup: "Δe1", width: 116 },
    { def: "enginePowerCheck.engine1deltaTQ", label: "ΔTQ", group: "epc", subgroup: "Δe1", width: 116 },
    { def: "enginePowerCheck.engine2DeltaN1", label: "ΔN1", group: "epc", subgroup: "Δe2", width: 116 },
    { def: "enginePowerCheck.engine2deltaT4", label: "ΔT4", group: "epc", subgroup: "Δe2", width: 116 },
    { def: "enginePowerCheck.engine2DeltaTOT", label: "ΔTOT", group: "epc", subgroup: "Δe2", width: 116 },
    { def: "enginePowerCheck.engine2deltaTQ", label: "ΔTQ", group: "epc", subgroup: "Δe2", width: 116 },
];

export const columnTitlesMap = new Map<string, string>([
    ["info", "GENERAL FLIGHT INFORMATION"],
    ["time", "TIME"],
    ["startstop", "START/STOP"],
    ["flighttime", "FLIGHT TIME"],
    ["totals", "TOTAL ENGINE HOURS AND CYCLES"],
    ["fuel", "FUEL SECTION"],
    ["defects", "DEFECT/REMARK - ACTION TAKEN"],
    ["oil", "OIL SUPPLIED BEFORE NEXT FLIGHT"],
    ["epc", "ENGINE POWER CHECK"],
    ["pax", "PASSENGERS"],
    ["crew", "CREW"],
    ["aTot", "AIRFRAME TOTALS"],
    ["hook", "HOOK"],
    ["hoist", "HOIST"],
    ["eTot", "ENGINE TOTALS"],
    ["tfbnf", "TOT. FUEL BEFORE NEXT FLIGHT"],
    ["rbbf", "REFUEL BEFORE FIRST FLIGHT"],
    ["farr", "FUEL ARRIVAL"],
    ["refuel", "REFUEL"],
    ["tfuel", "TOTAL FUEL"],
    ["hyd", "HYD"],
    ["location", "FUEL LOCATION"],
    ["mgb", "MGB"],
    ["tgb", "TGB"],
    ["e1", "Engine 1"],
    ["e2", "Engine 2"],
    ["Δe1", "Δ Engine 1"],
    ["Δe2", "Δ Engine 2"],
]);
